export enum SaleType {
  Efectivo,
  TarjetaDebito,
  TarjetaCredito = 7,
  Cheque = 8,
  Transferencia = 10,
}
